<template>
  <ChatbotAboutLayout
    title="Quantum Strategies Chatbot"
    what-it-is-subtitle="Explore national quantum strategies and policy reports"
    :description-paragraphs="descriptionParagraphs"
    :features="features"
    audience-subtitle="Built for policy and strategy work"
    :audience-items="audienceItems"
    :resources="resources"
    :video="video"
    cta-text="Ready to try it? Open the live chatbot →"
    cta-route-name="chatbotTab"
  />
</template>

<script>
import ChatbotAboutLayout from "@/components/ChatbotAboutLayout.vue";

export default {
  components: {
    ChatbotAboutLayout,
  },
  setup() {
    const descriptionParagraphs = [
      "National quantum strategies shape funding, research priorities, and industry direction — but finding the right detail across dozens of policy documents takes time. The Quantum Strategies Chatbot lets you query and compare insights from 62 national and regional quantum strategy documents (1999–2025), alongside policy reports from renowned institutions in our database.",
      "Select the strategies and reports you care about, ask precise questions, and get answers grounded in the source documents — with direct quotes you can verify.",
    ];

    const features = [
      {
        title: "Choose your documents",
        text: "Pick one or more national strategies or institutional policy reports by country, region, or year — or search the full library to narrow your scope.",
      },
      {
        title: "Ask strategy-focused questions",
        text: "Explore priorities, investments, timelines, and policy approaches — including comparisons across countries and regions.",
      },
      {
        title: "Verify with source quotes",
        text: "Every answer is backed by excerpts from the documents you selected; open quotes to read the original context.",
      },
    ];

    const audienceItems = [
      {
        title: "Who it's for",
        text: "Policy analysts, researchers, industry strategists, and anyone comparing how nations approach quantum technology.",
      },
      {
        title: "Best use cases",
        text: "Benchmarking national priorities, preparing briefings, spotting funding trends, and cross-country policy comparisons.",
      },
      {
        title: "Recurring usefulness",
        text: "Return whenever new strategies or policy reports are published, or when you need evidence-backed answers for reports and presentations.",
      },
    ];

    const resources = [
      {
        label: "European Quantum Flagship",
        href: "https://qt.eu/",
        description: "Background on Europe's coordinated quantum research and innovation efforts.",
      },
      {
        label: "EU quantum projects (EQRC Dashboard)",
        href: "https://dashboard.hybridintelligence.eu/",
        description: "Explore CORDIS-funded quantum projects by country, pillar, and funding — useful context alongside national strategy documents.",
      },
    ];

    const video = {
      src: "/videos/demo_quantum_strategy_chatbot_2.mp4",
      type: "video/mp4",
    };

    return {
      descriptionParagraphs,
      features,
      audienceItems,
      resources,
      video,
    };
  },
};
</script>
